<div class="container">
  <div fxLayout="row wrap">
    <div fxFlex="100">
      <h1 class="Join-title">
        Your first payment is due on the day you spend, and the balance is split over the next 2 paydays.
        Zero fees. Zero interest.
      </h1>
    </div>
  </div>
</div>
